module.exports = require("classnames");


/*****************
 ** WEBPACK FOOTER
 ** external "classnames"
 ** module id = 38
 ** module chunks = 0
 **/